import React, { useEffect, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
    getAdFromCreateTab,
    getProjectCreationStatus,
    getTemplateLoadingState,
} from '../../../store/selector/editor.selector';
import { useUpdateCaptionMutation } from '../../../store/api/campaign-ads.api';
import { useAppDispatch } from '../../../store/store';
import { SetCaptionForAdFromCreateTab } from '../../../store/slice/editor.slice';

interface IProps {
    store: any;
}

const Caption = ({ store }: IProps) => {
    const dispatch = useAppDispatch();
    const [updateCaption, { isLoading: captionUpdateLoading }] = useUpdateCaptionMutation();
    const [updateCaptionByAI, { isLoading: captionUpdateByAILoading }] = useUpdateCaptionMutation();
    const adFromCreateTab = useSelector(getAdFromCreateTab);
    const templateLoadingState = useSelector(getTemplateLoadingState);
    const projectCreationStatus = useSelector(getProjectCreationStatus);

    const [previewMode, setPreviewMode] = useState(false);
    const [currentCaption, setCurrentCaption] = useState('');
    const [aiCaptionPrompt, setAiCaptionPrompt] = useState('');

    const handleCaptionInputChange = (event: any) => {
        setCurrentCaption(event.target.value);
        saveCaption(event.target.value, '');
    };

    const handleAIPromptInputChange = (event: any) => {
        setAiCaptionPrompt(event.target.value);
    };

    const saveCaption = async (caption: string, prompt: string) => {
        if (adFromCreateTab) {
            let response = null;
            if (prompt.length > 0) {
                response = await updateCaptionByAI({
                    campaignAssetId: adFromCreateTab.campaignAdId,
                    newCaption: caption,
                    promptForCaption: prompt,
                });
            } else {
                response = await updateCaption({
                    campaignAssetId: adFromCreateTab.campaignAdId,
                    newCaption: caption,
                    promptForCaption: prompt,
                });
            }
            if (response && 'data' in response) {
                dispatch(SetCaptionForAdFromCreateTab(response.data));
            }
        }
    };

    useEffect(() => {
        if (adFromCreateTab) setCurrentCaption(adFromCreateTab.caption);
    }, [adFromCreateTab]);

    if (!adFromCreateTab) return null;

    return (
        <>
            {!templateLoadingState && !projectCreationStatus && (
                <div className="polotnoEditor">
                    <h2 className="text-dark fw-semibold mt-2 me-3 mb-2 ms-2">Caption</h2>
                    <div className="generate">
                        <div className="userPrompt tw-h-full tw-overflow-y-scroll">
                            {previewMode ? (
                                <></>
                            ) : (
                                <>
                                    <div>
                                        <Form className="position-relative">
                                            <Form.Group controlId="caption">
                                                <Form.Control
                                                    as="textarea"
                                                    rows={15}
                                                    value={currentCaption}
                                                    onChange={handleCaptionInputChange}
                                                    placeholder="Add caption here..."
                                                    className="productTextarea"
                                                />
                                            </Form.Group>
                                        </Form>
                                    </div>
                                    <div className="tw-pb-[100px]">
                                        <h3 className="text-dark fw-semibold mt-2 me-3 mb-2 ms-2">
                                            Ask AI to write or revise the caption
                                        </h3>
                                        <Form className="position-relative">
                                            <Form.Group controlId="captionFromAI">
                                                <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    value={aiCaptionPrompt}
                                                    onChange={handleAIPromptInputChange}
                                                    placeholder="Ask AI..."
                                                    className="productTextarea"
                                                />
                                            </Form.Group>
                                        </Form>
                                        <div className="w-100 d-flex justify-content-end mt-1">
                                            <Button
                                                variant="primary"
                                                onClick={() =>
                                                    saveCaption(currentCaption, aiCaptionPrompt)
                                                }
                                                disabled={
                                                    captionUpdateByAILoading ||
                                                    captionUpdateLoading ||
                                                    aiCaptionPrompt.length === 0
                                                }
                                            >
                                                Generate
                                                {captionUpdateByAILoading && (
                                                    <Spinner
                                                        as="span"
                                                        style={{
                                                            width: '1.5rem',
                                                            height: '1.5rem',
                                                        }}
                                                    />
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Caption;
